module.exports = __webpack_public_path__ + "static/media/19.9109134a.jpg";